
    <iframe [src]="urlSafe" width="100%" height="600px" frameborder="0"></iframe>
